import { Enum } from './Enum';

export class EmployeeLicenseStatus extends Enum {
  translationKey = 'employeeLicenseStatus';

  static readonly asArray: EmployeeLicenseStatus[] = [];

  static readonly byKey: { [name: string]: EmployeeLicenseStatus } = {};

  static readonly ACTIVE = new EmployeeLicenseStatus('ACTIVE');

  static readonly APPLICATION_SUBMITTED = new EmployeeLicenseStatus(
    'APPLICATION_SUBMITTED',
  );

  static readonly APPLICATION_IN_PROGRESS = new EmployeeLicenseStatus(
    'APPLICATION_IN_PROGRESS',
  );

  static readonly ENDORSEMENT_SUBMITTED = new EmployeeLicenseStatus(
    'ENDORSEMENT_SUBMITTED',
  );

  static readonly EXPIRED = new EmployeeLicenseStatus('EXPIRED');

  static readonly INACTIVE = new EmployeeLicenseStatus('INACTIVE');

  static readonly INACTIVE_DUE_PSOR = new EmployeeLicenseStatus(
    'INACTIVE_DUE_PSOR',
  );

  constructor(public readonly value: string) {
    super();
    EmployeeLicenseStatus.asArray.push(this);
    EmployeeLicenseStatus.byKey[value] = this;
  }

  static getColor(item: EmployeeLicenseStatus) {
    if (item === EmployeeLicenseStatus.ACTIVE) return 'success';
    if (item === EmployeeLicenseStatus.APPLICATION_IN_PROGRESS) return 'info';
    if (item === EmployeeLicenseStatus.APPLICATION_SUBMITTED) return 'info';
    if (item === EmployeeLicenseStatus.ENDORSEMENT_SUBMITTED) return 'info';
    if (item === EmployeeLicenseStatus.EXPIRED) return 'error';
    if (item === EmployeeLicenseStatus.INACTIVE) return 'closed';
    return 'closed';
  }

  static get asEditableArray(): EmployeeLicenseStatus[] {
    return this.asArray.filter(
      (item) => item !== EmployeeLicenseStatus.INACTIVE_DUE_PSOR,
    );
  }
}

export default EmployeeLicenseStatus;
